import React from 'react'
import { Link } from 'react-router-dom'
import { CNR, CNS } from 'constants/tokens'
import { FileTextOutlined } from '@ant-design/icons'

export default function AddressLink({ children, address }) {
  switch (address.toLowerCase()) {
    case CNR.address.toLowerCase():
      return (
        <Link to="/tokens/rise" style={{ display: 'flex', alignItems: 'center', minWidth: 110 }}>
          <FileTextOutlined style={{ marginRight: 4 }} />
          CNR Contract
          {/* children */}
        </Link>
      )
    case CNS.address.toLowerCase(): {
      return (
        <Link to="/tokens/swap" style={{ display: 'flex', alignItems: 'center', minWidth: 110 }}>
          <FileTextOutlined style={{ marginRight: 4 }} />
          CNS Contract
          {/* children */}
        </Link>
      )
    }
    default:
      return <Link to={`/account/${address}`}>{children}</Link>
  }
}

export function AddressType({ children, address }) {
  switch (address.toLowerCase()) {
    case CNR.address.toLowerCase():
      return (
        <span>
          <FileTextOutlined style={{ marginRight: 4 }} />
          CNR Contract
        </span>
      )
    case CNS.address.toLowerCase(): {
      return (
        <span>
          <FileTextOutlined style={{ marginRight: 4 }} />
          CNS Contract
        </span>
      )
    }
    default:
      return children
  }
}
